import {createApp} from 'vue'
import App from './App.vue'
import {router} from './router'

import ElementPlus from 'element-plus';
import {ElMessage} from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import 'element-plus/theme-chalk/index.css';
import {hasPermission} from '@/utils/permission.js'
import VueCookies from 'vue-cookies'
import './assets/css/main.css';
import './assets/js/main';
import axios from "@/utils/axios";
import zhCn from "element-plus/es/locale/lang/zh-cn";

//时间格式化
// 定义全局时间戳过滤器
// Vue.filter('formatDate', function(value, reg) {
//   return Moment(value).format(reg)
// })

async function main() {

    // 获取系统设置
    window.global.systemset = {name:"军舰鸟灵活用工大数据平台",title:"军舰鸟灵活用工大数据平台",logo_path:[{"ext": "", "url": "./assets/images/logo.png", "name": "2x.png", "size": 96465, "newName": ""}],icon_path:[{"ext": "", "url": "/logo.png", "name": "2x.png", "size": 96465, "newName": ""}],copyright:"Copyright © 2016-2025 苏州瓴聘信息科技有限公司 | 江苏省苏州市吴中区太湖东路9号澹台湖大厦1108-2号号版权所有 保留一切权利 备案号:苏ICP备2025156163号-1"}
    //hook_systemset
    document.querySelector('link[rel="icon"]').href = baseUrl+window.global.systemset.icon_path[0].url;
    document.title = window.global.systemset.title

    // 判断是否登陆
    if (window.location.pathname != "/Login") {

        if (VueCookies.get("token")) {
            // 获取字典数据
            console.log("________1___________",new Date().toISOString()); // 输出ISO格式的日期和时间
            let err = await axios.get('/Dict/List').then((data) => {
                console.log("_______2_______________",new Date().toISOString()); // 输出ISO格式的日期和时间
                window.global.dict = data.data
            }).catch(error => {
                ElMessage.error('获取数据失败，请检查后台运行状态！')
                return true
            })
            if (err)return
            console.log("_______3_______________",new Date().toISOString()); // 输出ISO格式的日期和时间
            // 获取登陆信息
            err = await axios.get('/User/InfoByToken?token=' + VueCookies.get("token")).then((data) => {
                window.global.userinfo = data.data
                console.log("_______4_______________",new Date().toISOString()); // 输出ISO格式的日期和时间
            }).catch(error => {
                window.location.href = "/Login"
                return true
            })
            if (err)return

            // 创建vue
            var app = createApp(App).use(router).use(ElementPlus, {locale: zhCn})
            Object.keys(ElementPlusIconsVue).forEach((key) => {
                app.component(key, ElementPlusIconsVue[key]);//JS中用这行
            });

            router.isReady().then(() => {
                app.mount('#app')
            })
            console.log("_______4_______________",new Date().toISOString()); // 输出ISO格式的日期和时间
            // 权限处理
            app.directive('hasPermission', hasPermission)
            console.log("_______5_______________",new Date().toISOString()); // 输出ISO格式的日期和时间
        } else {
            window.location.href = "/Login"
        }
    }else{
        // 创建vue
        var app = createApp(App).use(router).use(ElementPlus, {locale: zhCn})
        app.component("User", ElementPlusIconsVue["User"]);
        app.component("Lock", ElementPlusIconsVue["Lock"]);
        app.component("Key", ElementPlusIconsVue["Key"]);
        app.mount('#app')
    }
};
main()



